/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_CitypartInputs */

const cs_projects_citypart = /** @type {(inputs: Projects_CitypartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Městská část`)
};

const en_projects_citypart = /** @type {(inputs: Projects_CitypartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City part`)
};

/**
* | output |
* | --- |
* | "City part" |
*
* @param {Projects_CitypartInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_citypart = /** @type {((inputs?: Projects_CitypartInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_CitypartInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_citypart(inputs)
	return cs_projects_citypart(inputs)
});